const plain = (value: any) => (typeof value?.toJSON === 'function' ? value.toJSON() : value);

/** Legacy Backbone propositions and API DTOs must produce the same persisted condition. */
export const serializeComposerExpression = (value: any): any => {
    const expression = plain(value);
    return expression
        ? {
              op: expression.op ?? 'AND',
              propositions: (expression.propositions ?? []).map((value: any) => {
                  const proposition = plain(value);
                  return {
                      attributeGuid: proposition.attributeGuid ?? null,
                      op: proposition.op ?? null,
                      value: proposition.value ?? null
                  };
              }),
              expressions: (expression.expressions ?? []).map(serializeComposerExpression)
          }
        : null;
};
